var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5AA587"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.33,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.67,
    style: {
      fill: "#464655"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 155.51,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 21.28
  }), /*#__PURE__*/React.createElement("rect", {
    y: 335.21,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 21.28
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M244.324,262.983c3.493-3.57,3.493-10.397,0-13.966L0,0v512L244.324,262.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M102.444,168.354l19.698,59.061l62.257,0.483c3.481,0.027,4.925,4.47,2.124,6.538L136.44,271.42  l18.78,59.359c1.05,3.319-2.729,6.065-5.561,4.041l-50.651-36.203L48.357,334.82c-2.832,2.024-6.611-0.721-5.561-4.041l18.78-59.359  L11.49,234.436c-2.801-2.068-1.357-6.511,2.124-6.538l62.257-0.483l19.698-59.061C96.671,165.052,101.342,165.052,102.444,168.354z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M95.396,278.05l-4.87,4.899H49.808l11.113-40.779l4.541-2.27l-7.289,36.357   c-0.06,0.448,0.03,0.896,0.329,1.255c0.269,0.358,0.687,0.538,1.135,0.538H95.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M105.165,284.832c-1.763,1.314-3.914,2.061-6.154,2.061s-4.391-0.747-6.154-2.061l6.154-6.154   L105.165,284.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M148.214,282.95h-40.719l-4.87-4.899h35.76c0.448,0,0.866-0.179,1.135-0.538   c0.299-0.358,0.388-0.807,0.329-1.255l-7.289-36.357l4.541,2.27L148.214,282.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M136.563,275.063h-36.059v-37.194c6.035-5.109,21.958-1.613,28.709,0.478L136.563,275.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M97.517,237.869v37.194H61.459l7.349-36.716C75.559,236.256,91.482,232.761,97.517,237.869z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M151.62,284.055l-11.8-43.318c-0.119-0.388-0.388-0.747-0.777-0.926l-7.887-3.943   c-0.03-0.03-0.06-0.03-0.12-0.03c-0.03,0-0.03-0.03-0.06-0.06c-0.956-0.329-22.794-7.439-31.966-0.478   c-9.171-6.961-31.01,0.149-31.966,0.478c-0.03,0.03-0.03,0.03-0.06,0.06c-0.06,0-0.09,0-0.12,0.03l-7.887,3.943   c-0.388,0.179-0.657,0.538-0.777,0.926l-11.8,43.318c-0.12,0.448-0.03,0.926,0.239,1.285c0.299,0.358,0.747,0.598,1.195,0.598   H89.66c2.48,2.479,5.826,3.943,9.351,3.943s6.871-1.464,9.351-3.943h41.824c0.448,0,0.896-0.239,1.195-0.598   C151.65,284.981,151.739,284.503,151.62,284.055z M100.505,237.869c6.035-5.109,21.958-1.613,28.709,0.478l7.349,36.716h-36.059   v-37.194L100.505,237.869L100.505,237.869z M68.808,238.347c6.752-2.091,22.675-5.587,28.709-0.478v37.194H61.459L68.808,238.347z    M49.808,282.95l11.113-40.779l4.541-2.27l-7.289,36.357c-0.06,0.448,0.03,0.896,0.329,1.255c0.269,0.358,0.687,0.538,1.135,0.538   h35.76l-4.87,4.899H49.808z M99.011,286.893c-2.241,0-4.391-0.747-6.154-2.061l6.154-6.154l6.154,6.154   C103.402,286.146,101.251,286.893,99.011,286.893z M107.495,282.95l-4.87-4.899h35.76c0.448,0,0.866-0.179,1.135-0.538   c0.299-0.358,0.388-0.807,0.329-1.255l-7.289-36.357l4.541,2.27l11.113,40.779L107.495,282.95L107.495,282.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M136.359,198.851c-1.523,1.062-3.588,0.879-4.901-0.434l-1.987-1.987v4.864l-12.16,12.16h-4.864   L92.991,232.91h-4.864L50.72,270.317c-0.921,0.921-1.243,2.284-0.831,3.52l1.76,5.279l-7.296,7.296h-4.864l-14.872,14.872   c-1.188,1.188-1.188,3.115,0,4.303l9.814,9.814c1.417,1.417,3.739,1.327,5.043-0.194l21.902-26.363l2.432-7.296l4.864-4.864   l9.728,14.592l7.296-7.296l-7.782-11.673l1.938-1.938c1.884-1.884,1.884-4.939,0-6.824l-1.452-1.452l1.367-1.367   c10.379,8.895,22.844,11.194,34.712,6.108l-4.064-9.483c-9.805,4.202-17.812,0.687-23.383-3.891l20.55-20.55l-0.811-4.053   l5.674-5.674h4.864l36.479-36.479L136.359,198.851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M63.809,193.998l-4.864,4.864c-1.343,1.343-1.343,3.521,0,4.864l0.81,0.81l-8.106,1.622   l-21.887,21.887l12.16,12.16l21.887-21.887l1.621-8.107l3.243,3.243l2.432-2.432L152,291.917l4.864-4.864l-80.895-80.895   l2.432-2.432l-9.728-9.728C67.329,192.655,65.152,192.655,63.809,193.998z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMz);
export default __webpack_public_path__ + "static/media/mz.003979f606accab50433f80cfd1e7f6b.svg";
export { ForwardRef as ReactComponent };